import React, { useEffect, useState } from 'react';
import { cameraService } from '../../../services/central-api/cameras';
import { translate } from '../../../services/translate';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';

interface Props {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
    zIndex: number;
    userText: string;
    setUserText: React.Dispatch<React.SetStateAction<string>>;
}

function DownloadUserDropdown({ value, setValue, zIndex, userText, setUserText }: Props) {
    const [items, setItems] = useState<{ label: string; value: string; }[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [filterTimeout, setFilterTimeout] = useState<NodeJS.Timeout>();

    async function getItems(textFilter: string) {
        try {
            setIsLoading(true);
            const users = await cameraService.getSimplifiedDownloadUsers(textFilter);
            setItems(users.map((user) => ({
                value: String(user.id),
                label: user.warName ?? user.name
            })));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (userText && userText.length > 2) {
            getItems(userText);
        }
    }, [userText]);

    return (
        <FilterDropdown
            label={translate('user')}
            placeholder={translate('typeToSearch')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            searchable={false}
            disableLocalSearch={true}
            loading={isLoading}
            onChangeSearchText={(text) => {
                if (text && text.length > 2) {
                    if (filterTimeout) {
                        clearTimeout(filterTimeout);
                    }
                    const timeout = setTimeout(() => {
                        setUserText(text);
                    }, 1000);
                    setFilterTimeout(timeout);
                }
            }}
        />
    );
}

export default DownloadUserDropdown;
